<script lang="ts">
  export let dark = false;
  import Auth from '$lib/components/Auth.svelte';
  import UserAvatar from '$lib/components/UserAvatar.svelte';
  import { page } from '$app/stores';
</script>

<div class="min-h-screen flex flex-col overflow-x-hidden">
  <div
    class="border-b-0 border-grey-aux {!dark && !$page.url.pathname.includes('explore')
      ? 'md:border-b'
      : ''}"
  >
    <nav class="main-nav pt-4 pb-3 md:py-4 max-w-container mx-auto gap-2">
      <a href="/" rel="external" class="text-primary md:hidden" class:dark>
        <i class="logo icon-bitski-filled" />
      </a>
      <!-- svelte-ignore a11y-missing-content -->
      <a
        href="/"
        rel="external"
        class="hidden md:flex text-primary full-logo h-6 logo-width"
        class:dark
      />
      <div class="flex-grow" />
      <a
        href="https://apps.apple.com/app/apple-store/id1587199538?pt=118421671&ct=navigation-header&mt=8"
        class="btn btn-text hidden md:block text-primary rounded"
      >
        <span class="icon-apple" /> iOS App
      </a>
      <a
        href="https://chrome.google.com/webstore/detail/bitski/feejiigddaafeojfddjjlmfkabimkell"
        class="btn btn-text hidden md:block text-primary rounded"
      >
        <span class="icon-globe-chonk" /> Extension
      </a>
      {#if $page.data.user}
        <UserAvatar user={$page.data.user} />
      {:else}
        <div class:dark class="flex md:inline">
          <Auth className="btn btn-primary" />
        </div>
      {/if}
    </nav>
  </div>
  <div class="items-center mx-auto md:py-8 w-full flex-grow flex flex-col">
    <slot />
  </div>
</div>
<footer class="border-t border-grey-aux h-10 caption mt-4 md:mt-0">
  <div class="max-w-container mx-auto px-4 sm:px-14">
    <div class="flex flex-col-reverse sm:flex-row justify-between md:pt-12 pt-6 pb-8 md:pb-2">
      <div>
        <div class="full-logo mb-5" />
        <div class="text-grey mb-2">
          Bitski, Inc. <br />
          548 Market St, Suite 84688 <br />
          San Francisco, CA 94104-5401 <br />
        </div>
        <div class="text-grey text-xl">
          <a aria-label="twitter" rel="external" href="https://twitter.com/bitski">
            <i class="icon-twitter" />
          </a>
        </div>
      </div>
      <div class="flex flex-wrap mb-10 md:gap-16">
        <div class="flex w-full md:w-auto md:gap-16 gap-20">
          <div>
            <h6 class="body-bold mb-2">SDKs</h6>
            <ul class="flex flex-col gap-1">
              <ol><a rel="external" href="https://github.com/bitskico/bitski-js">JavaScript</a></ol>
              <ol><a rel="external" href="https://github.com/bitskico/bitski-node">Node.js</a></ol>
              <ol>
                <a rel="external" href="https://github.com/bitskico/bitski-truffle-provider">
                  Truffle
                </a>
              </ol>
              <ol><a rel="external" href="https://github.com/bitskico/Bitski-iOS-SDK">iOS</a></ol>
              <ol><a rel="external" href="https://github.com/bitskico/bitski-unity">Unity</a></ol>
            </ul>
          </div>
          <div>
            <h6 class="body-bold mb-2">Resources</h6>
            <ul class="flex flex-col gap-1">
              <ol><a rel="external" href="https://www.bitski.com/blog">Blog</a></ol>
              <ol><a rel="external" href="https://www.bitski.com/docs">Docs</a></ol>
              <ol><a rel="external" href="https://developer.bitski.com">Dev Portal</a></ol>
              <ol><a rel="external" href="https://github.com/bitskico">GitHub</a></ol>
              <ol><a rel="external" href="https://support.bitski.com/">Support</a></ol>
            </ul>
          </div>
        </div>
        <div class="mt-5 md:mt-0">
          <h6 class="body-bold mb-2">Company</h6>
          <ul class="flex flex-col gap-1">
            <ol><a href="mailto:support@bitski.com">Contact Us</a></ol>
            <ol>
              <a
                rel="external"
                href="https://www.notion.so/otl/Join-Bitski-26813e8c8234418e8984f9f2050a5a84"
              >
                Jobs
              </a>
            </ol>
          </ul>
        </div>
      </div>
    </div>

    <div
      class="flex flex-col-reverse sm:flex-row items-center justify-between border-t border-grey-aux pt-4 pb-8 gap-4"
    >
      <span class="caption-bold text-grey">
        Copyright © {new Date().getFullYear()} Bitski Inc. All rights reserved.
      </span>

      <div>
        <a
          href="https://www.notion.so/otl/TOS-2-1-21-1f9a98659e6446479479339a23185d2f"
          rel="external"
          class="mr-4"
        >
          Terms & Conditions
        </a>
        <a
          href="https://www.notion.so/otl/Privacy-Policy-c166160b6c544e909dd04176f43081d6"
          rel="external"
        >
          Privacy Policy
        </a>
      </div>
    </div>
  </div>
</footer>
